// extracted by mini-css-extract-plugin
export var displayNone = "_r1-6";
export var imgContainer = "_r1-2";
export var overflowHidden = "_r1-3";
export var productInfoCardButtonContainer = "_r1-5";
export var productTitleText = "_r1-4";
export var rightArrow = "_r1-1";
export var rightArrowContainer = "_r1-0";